<template>
  <div>
    <div>
      <el-dialog
        :title="mainTitle"
        :visible.sync="editVisible"
        width="600px"
        @close="closeEdit"
        @open="dlgOpen"
        @closed="dlgClosed"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
      >
        <el-form
          ref="menuForm"
          :model="menuForm"
          label-width="120px"
          :rules="rules"
          :style="dlgBody"
          v-loading="loading"
        >
          <el-form-item label="系统分类" prop="systemId">
            <el-select
              v-model.trim="menuForm.systemId"
              placeholder="请选择系统分类"
              style="width:90%"
              clearable
              disabled
            >
              <el-option
                v-for="item in systemData"
                :key="item.value"
                :label="item.key"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属平台" prop="type">
            <el-select
              v-model.trim="menuForm.type"
              placeholder="请选择所属平台"
              style="width:90%"
              disabled
            >
              <el-option
                v-for="item in menuType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="类型" prop="level">
            <el-select
              v-model.trim="menuForm.level"
              placeholder="请选择类型"
              style="width:90%"
              @change="changeLevel(menuForm.level)"
            >
              <el-option
                v-for="item in levelType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="功能名称" prop="name">
            <el-input
              v-model.trim="menuForm.name"
              placeholder="请输入功能名称"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="父路由名称" prop="parentRouteName">
            <el-input
              v-model.trim="menuForm.parentRouteName"
              placeholder="请输入父路由名称"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="路由名称" prop="routeName">
            <el-input
              v-model.trim="menuForm.routeName"
              placeholder="请输入路由名称"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="路由path" prop="routePath">
            <el-input
              v-model.trim="menuForm.routePath"
              placeholder="请输入路由path"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="路由参数" prop="routeParam">
            <el-input
              v-model.trim="menuForm.routeParam"
              placeholder="请输入路由参数"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="菜单icon" prop="iconUrl">
            <el-input
              v-model="menuForm.iconUrl"
              placeholder="请输入菜单icon"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="选中的菜单icon" prop="iconSelectedUrl" v-if="isApp==true">
            <el-input
              v-model.trim="menuForm.iconSelectedUrl"
              placeholder="请输入排序"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="URL" prop="url">
            <el-input v-model.trim="menuForm.url" placeholder="请输入URL" clearable style="width:90%"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model.trim="menuForm.sort" placeholder="请输入排序" clearable style="width:90%"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetForm('menuForm')">取 消</el-button>
          <el-button type="primary" @click="onSubmit('menuForm')" :disabled="btnDisabled">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import DialogResize from "@/utils/DialogResize.js";
import SettingApi from "@/api/setting.js";
export default {
  mixins: [DialogResize],
  components: {},
  data() {
    return {
      loading: false,
      btnDisabled: false,
      levelType: [
        {
          value: "1",
          label: "导航"
        },
        {
          value: "2",
          label: "菜单"
        }
      ],
      menuType: [
        {
          value: "1",
          label: "Web"
        },
        {
          value: "2",
          label: "App"
        }
      ],
      systemData: [],
      operateFlag: "",
      isApp: false,
      isShowRouteName: false,
      mainTitle: "",
      editVisible: false,
      menuForm: {
        id: "",
        parentId: "",
        parentName: "",
        name: "",
        url: "",
        level: "",
        type: "",
        iconUrl: "",
        iconSelectedUrl: "",
        routeName: "",
        routePath: "",
        routeParam: "",
        parentRouteName: "",
        sort: "",
        systemId: ""
      },
      rules: {
        level: [{ required: true, message: "类型不能为空", trigger: "change" }],
        // parentName: [
        //   { required: true, message: "登录权限不能为空", trigger: "change" }
        // ],
        name: [
          { required: true, message: "功能名称不能为空", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "功能名称输入不能超过100个字符，请重新输入",
            trigger: "blur"
          },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
            message: "不允许输入空格等特殊符号"
          }
        ],
        iconUrl: [
          { required: false, message: "菜单icon不能为空", trigger: "blur" },
          {
            min: 1,
            max: 150,
            message: "菜单icon输入不能超过150个字符，请重新输入",
            trigger: "blur"
          }
        ],
        url: [
          { required: true, message: "URL不能为空", trigger: "blur" },
          {
            min: 1,
            max: 150,
            message: "URL输入不能超过150个字符，请重新输入",
            trigger: "blur"
          },
          {
            pattern: /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/,
            message: "请输入正确的URL格式"
          }
        ],
        sort: [
          { required: true, message: "排序不能为空", trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "排序输入不能超过10个字符，请重新输入",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]*$/,
            message: "排序只能输入数字"
          }
        ],
        routeName: [
          { required: true, message: "路由名称不能为空", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "路由名称输入不能超过50个字符，请重新输入",
            trigger: "blur"
          }
        ],
        iconSelectUrl: [
          {
            required: true,
            message: "选中的菜单icon不能为空",
            trigger: "blur"
          },
          {
            min: 1,
            max: 150,
            message: "选中的菜单icon输入不能超过150个字符，请重新输入",
            trigger: "blur"
          },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
            message: "不允许输入空格等特殊符号"
          }
        ],
        routePath: [
          { required: false, message: "路由path不能为空", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "路由path输入不能超过100个字符，请重新输入",
            trigger: "blur"
          }
        ],
        routeParam: [
          { required: false, message: "路由参数不能为空", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "路由参数输入不能超过50个字符，请重新输入",
            trigger: "blur"
          }
        ],
        parentRouteName: [
          { required: false, message: "父路由名称不能为空", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "父路由名称输入不能超过50个字符，请重新输入",
            trigger: "blur"
          },
          {
            // pattern: /^\/[^\s]+$/,
            pattern: /^[/][a-zA-Z0-9/]+$/,
            message: "以/开头且不能输入空格等其他特殊字符"
          }
        ],
        systemId: [
          { required: false, message: "系统ID不能为空", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    init(param, row, operateFlag, platformType, systemType) {
      this.loading = false;
      this.btnDisabled = false;
      this.initSystemData();
      if (platformType == "2") {
        this.isApp = true;
        this.isShowRouteName = true;
        // this.rules.url[0].routeName = true;
        // this.rules.url[0].iconSelectUrl = false;
      } else {
        this.isShowRouteName = false;
        this.isApp = false;
      }
      if (operateFlag == "add") {
        this.mainTitle = "新增";
        this.operateFlag = "add";
        this.menuForm.parentName = param.parentName;
        this.menuForm.parentId = param.parentId;
        this.menuForm = {
          id: "",
          parentId: param.parentId,
          parentName: param.parentName,
          name: "",
          url: "",
          level: "",
          type: platformType,
          iconUrl: "",
          iconSelectedUrl: "",
          routeName: "",
          routePath: "",
          routeParam: "",
          parentRouteName: "",
          sort: "",
          systemId: systemType
        };
      }
      if (operateFlag == "update") {
        this.mainTitle = "编辑";
        this.operateFlag = "update";
        this.menuForm.parentName = param.parentName;
        this.menuForm.parentId = param.parentId;
        if (row.level == 1) {
          //非必填
          this.isShowRouteName = false;
          this.rules.url[0].required = false;
          this.rules.routeName[0].required = false;
        } else {
          this.isShowRouteName = true;
          this.rules.routeName[0].required = true;
          this.rules.url[0].required = true;
        }
        this.getDataById(row.id, systemType);
      }
      this.editVisible = true;
    }, //清空表单验证
    resetForm(formName) {
      this.$refs["menuForm"].resetFields();
      this.editVisible = false;
    },
    closeEdit() {
      this.$refs["menuForm"].resetFields();
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.btnDisabled = true;
          let v = this.menuForm;
          let param = {
            id: v.id,
            type: v.type,
            level: v.level,
            parentId: v.parentId == "" || v.parentId == null ? 0 : v.parentId,
            name: v.name,
            iconUrl: v.iconUrl,
            url: v.url,
            sort: v.sort,
            routeName: v.routeName,
            routePath: v.routePath,
            iconSelectedUrl: v.iconSelectedUrl,
            routeParam: v.routeParam,
            parentRouteName: v.parentRouteName,
            systemId: v.systemId
          };
          SettingApi.getClass()
            .saveMenu(param)
            .then(res2 => {
              if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                this.$message.success("保存成功！");
                this.loading = false;
                this.btnDisabled = false;
                //关闭弹窗
                this.editVisible = false;
                //刷新左边树的数据
                // this.onloadGroup(false);
                this.$parent.onloadGroup();
                //刷新右边列表数据
                this.$parent.getListData(v.parentId);
              } else {
                this.loading = false;
                this.btnDisabled = false;
                this.$message.error(res2.data.msg);
                return false;
              }
            })
            .catch(err => {
              this.loading = false;
              this.btnDisabled = false;
              this.$message.error(err);
              return false;
            });
        } else {
          this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    getChangeType() {},
    changeLevel(val) {
      if (val == 1) {
        //非必填
        this.isShowRouteName = false;
        this.rules.url[0].required = false;
        this.rules.routeName[0].required = false;
      } else {
        this.isShowRouteName = true;
        this.rules.routeName[0].required = true;
        this.rules.url[0].required = true;
      }
    },
    initSystemData() {
      this.$mhttp
        .httpGet(this.$constant.API_NSC + "uc/system/systems", null, null)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            let obj = {};
            this.systemData = [];
            for (let i = 0; i < data.length; i++) {
              obj = {
                value: data[i].id,
                key: data[i].name
              };
              this.systemData.push(obj);
            }
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    },
    getDataById(id, systemType) {
      this.loading = true;
      this.btnDisabled = true;
      SettingApi.getClass()
        .getMenuById(id)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.loading = false;
            this.btnDisabled = false;
            let data = res2.data.data;
            this.menuForm = {
              id: data.id,
              parentId: data.parentId,
              parentName: data.parentName,
              name: data.name,
              url: data.url,
              level: data.level,
              type: data.type,
              iconUrl: data.iconUrl,
              iconSelectedUrl: data.iconSelectedUrl,
              routeName: data.routeName,
              routePath: data.routePath,
              routeParam: data.routeParam,
              parentRouteName: data.parentRouteName,
              sort: data.sort + "",
              systemId: systemType
            };
          } else {
            this.loading = false;
            this.btnDisabled = false;
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.btnDisabled = false;
          this.$message.error(err);
          return false;
        });
    }
  }
};
</script>
<style scoped>
.icon-sea {
  margin: -10px;
  margin-left: 10px;
}
</style>
